import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import UploadSection from "./UploadSection";
import FolderSection from "./FolderSection";
import SplitViewSideBarToggle from '../../../../Components/SplitViewSideBarToggle';

const sideBar = (props) => {
    return(
        <SplitViewSideBarToggle>
        <div className="filter_Header p-2">
            <UploadSection
              toggleDirectoryChoosePopup={props.toggleDirectoryChoosePopup} 
            />
        </div>
        <div className="filter_Body p-0">
            <FolderSection 
              toggleFolderPopup={props.toggleFolderPopup} 
              directoryLists={props.directoryLists} 
              istoggleDirectoryAction={props.istoggleDirectoryAction}
              toggleDirectoryActionHandler={props.toggleDirectoryActionHandler}
              deleteDirectoryHandler={props.deleteDirectoryHandler}
              toggleSubFolderPopup={props.toggleSubFolderPopup}
              editFolderHandler={props.editFolderHandler}
              downloadDirectoryHandler={props.downloadDirectoryHandler}
              assignListingModules={props.assignListingModules}
              ListingModules={props.ListingModules}
              ListingDirectoryID={props.ListingDirectoryID}
              />
        </div>
        </SplitViewSideBarToggle>
    )
}

export default sideBar;